// src/pages/customer-panel/appointments/AppointmentSettingsPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AppointmentSettingsSection from '../settings/AppointmentSettingsSection';

const fontFamily = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif";

export default function AppointmentSettingsPage() {
    const navigate = useNavigate();

    return (
        <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1000, mx: 'auto' }}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/customer-panel/appointments')}
                sx={{ fontFamily, textTransform: 'none', color: '#64748b', fontWeight: 600, mb: 2 }}
            >
                Back to Appointments
            </Button>

            <Box sx={{ mb: 3 }}>
                <Typography sx={{ fontFamily, fontWeight: 800, fontSize: '1.6rem', color: '#1e293b' }}>
                    Appointment Settings
                </Typography>
                <Typography sx={{ fontFamily, fontSize: '0.88rem', color: '#64748b', mt: 0.3 }}>
                    Configure booking rules, availability, holidays, and special days
                </Typography>
            </Box>

            <Paper sx={{ borderRadius: '16px', border: '1px solid', borderColor: 'grey.100', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', p: { xs: 2, md: 3 } }}>
                <AppointmentSettingsSection />
            </Paper>
        </Box>
    );
}
